if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');
      this.stickyForm = this.querySelector('.js-sticky-atc-form');
      this.stickyVariantInput = this.stickyForm?.querySelector('input[name="id"]');
      this.stickyQuantityInput = this.stickyForm?.querySelector('.js-sticky-atc-quantity');
      this.stickySubmitButton = this.stickyForm?.querySelector('[name="add"]');
      this.shortDesktopMedia = window.matchMedia('(min-width: 1024px) and (max-height: 820px)');
      this.showOnShortDesktop = this.dataset.showOnShortDesktop === 'true';
      this.syncStickyForm = this.syncStickyForm.bind(this);
      this.handleViewportChange = this.handleViewportChange.bind(this);

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
      this.productSection?.removeEventListener('change', this.syncStickyForm);
      this.productSection?.removeEventListener('input', this.syncStickyForm);
      this.stickyForm?.removeEventListener('submit', this.syncStickyForm, { capture: true });
      document.removeEventListener('on:variant:change', this.syncStickyForm);
      this.shortDesktopMedia.removeEventListener('change', this.handleViewportChange);
      this.observer?.disconnect();
    }

    bindEvents() {
      this.createObserver();

      if (this.showOnShortDesktop) {
        this.shortDesktopMedia.addEventListener('change', this.handleViewportChange);
      }

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);
      this.productSection.addEventListener('change', this.syncStickyForm);
      this.productSection.addEventListener('input', this.syncStickyForm);
      this.stickyForm?.addEventListener('submit', this.syncStickyForm, { capture: true });
      document.addEventListener('on:variant:change', this.syncStickyForm);
      StickyAtcPanel.handleScroll();
      this.syncStickyForm();
    }

    createObserver() {
      this.observer?.disconnect();

      if (this.isShortDesktop()) {
        this.classList.remove('sticky-atc-panel--out');
      }

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.productForm && !theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.boundingClientRect.bottom > 0);
          } else if (entry.target === this.productInfo && theme.mediaMatches.md) {
            if (this.isShortDesktop()) {
              this.classList.remove('sticky-atc-panel--out');
            } else {
              this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
            }
          }
        });
      });

      if (this.productForm) this.observer.observe(this.productForm);
      if (this.productInfo) this.observer.observe(this.productInfo);
    }

    isShortDesktop() {
      return this.showOnShortDesktop && this.shortDesktopMedia.matches;
    }

    handleViewportChange() {
      if (!this.isShortDesktop()) {
        this.classList.add('sticky-atc-panel--out');
      }

      this.createObserver();
    }

    syncStickyForm() {
      if (!this.stickyForm) return;

      const mainVariantInput = this.productForm?.querySelector('input[name="id"]');
      const mainQuantityInput = this.productForm?.querySelector('input[name="quantity"]');
      const mainSubmitButton = this.productForm?.querySelector('[name="add"]');

      if (this.stickyVariantInput && mainVariantInput) {
        this.stickyVariantInput.value = mainVariantInput.value;
      }

      if (this.stickyQuantityInput) {
        this.stickyQuantityInput.value = mainQuantityInput?.value || '1';
      }

      if (this.stickySubmitButton && mainSubmitButton) {
        this.stickySubmitButton.disabled = mainSubmitButton.disabled;
        this.stickySubmitButton.textContent = mainSubmitButton.textContent.trim()
          || this.stickySubmitButton.dataset.addToCartText;
      }
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
